import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnHR: CultureInfo = {
  name: 'en-HR',
  displayName: 'English (Croatia)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-HR',
  parent: CultureInfoEn
};
